export function HowItWorksSection() {
  const steps = [
    {
      number: '01',
      icon: 'ri-pencil-ruler-2-line',
      title: 'Tell us what is slipping through the cracks',
      description:
        'Share where you are losing leads today — missed calls, slow follow-up, no online booking, or too much admin work.',
    },
    {
      number: '02',
      icon: 'ri-magic-line',
      title: 'We map the simplest automation setup',
      description:
        'We recommend the right mix of AI answering, lead follow-up, and scheduling so your page works for your business, not against it.',
    },
    {
      number: '03',
      icon: 'ri-rocket-line',
      title: 'You start capturing more opportunities',
      description:
        'We launch the system, test the flow, and keep everything moving so more people get answered, followed up, and booked.',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-primary/10 text-primary text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-5">
            How It Works
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-secondary mb-4 leading-tight">
            A simple process. No complicated software. No pressure.
          </h2>
          <p className="text-xl text-gray-600 font-light leading-relaxed">
            We keep the setup straightforward so you can move from missed calls to booked appointments without adding more busywork.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div
              key={step.number}
              className="relative bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-start justify-between gap-4 mb-6">
                <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center shrink-0">
                  <i className={`${step.icon} text-primary text-2xl`} />
                </div>
                <div className="text-4xl font-bold text-gray-100 leading-none">{step.number}</div>
              </div>

              <h3 className="font-display text-2xl font-bold text-secondary mb-4 leading-tight">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
